<template>
    <div v-bind:class="{ 'dropdown': !navigation }" @click="toggleMenu">
        <slot></slot>
        <div v-bind:class="{ 'dropdown-menu-right': right, 'show': show, 'dropdown-menu': !navigation, 'collapse navbar-collapse': navigation }" v-on:click.stop ref="dropdown">
            <slot name="dropdown"></slot>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
        right: {
            type: Boolean,
            default: false,
        },
        navigation: {
            type: Boolean,
            default: false,
        }
    },
    data () {
      return {
        show: false,
      }
    },
    mounted () {
        document.body.addEventListener('click', this.closeMenu);
        window.addEventListener('keyup', this.listenForTab);
    },
    destroyed () {
        document.body.removeEventListener('click', this.closeMenu);
        window.removeEventListener('keyup', this.listenForTab);
    },
    computed: {
        dropClasses: function() {
            if (this.navigation) {
                return '';
            } else {
                return ;
            }
        }
    },
    methods: {
        closeMenu ($event) {
            if (!$event || !this.$el.contains($event.target)) {
                if (this.show) {
                    this.show = false;
                }
            }
        },
        listenForTab: function(event) {
            if (event.keyCode == 9) {
                if (!this.$el.contains(event.target)) {
                    if (this.show) {
                        this.show = false;
                    }
                }
            }
        },
        toggleMenu () {
            if (this.show) {
                this.show = false;
            } else {
                this.show = true;
            }
        },
    },
  }
</script>